"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlers = void 0;
const unknown_error_1 = require("./unknown-error");
const additional_properties_1 = require("./additional-properties");
const any_of_1 = require("./any-of");
const array_size_1 = require("./array-size");
const comparison_1 = require("./comparison");
const enum_1 = require("./enum");
const format_1 = require("./format");
const if_then_else_1 = require("./if-then-else");
const multiple_of_1 = require("./multiple-of");
const pattern_1 = require("./pattern");
const required_1 = require("./required");
const string_size_1 = require("./string-size");
const type_1 = require("./type");
const unique_1 = require("./unique");
const allHandlers = {
    unknownError: unknown_error_1.prettify,
    additionalProperties: additional_properties_1.prettify,
    anyOf: any_of_1.prettify,
    not: any_of_1.prettify,
    maxItems: array_size_1.prettify,
    minItems: array_size_1.prettify,
    maximum: comparison_1.prettify,
    exclusiveMaximum: comparison_1.prettify,
    minimum: comparison_1.prettify,
    exclusiveMinimum: comparison_1.prettify,
    const: enum_1.prettify,
    enum: enum_1.prettify,
    format: format_1.prettify,
    if: if_then_else_1.prettify,
    multipleOf: multiple_of_1.prettify,
    pattern: pattern_1.prettify,
    required: required_1.prettify,
    maxLength: string_size_1.prettify,
    minLength: string_size_1.prettify,
    type: type_1.prettify,
    uniqueItems: unique_1.prettify,
};
exports.handlers = allHandlers;
